import React, { useState } from 'react';
import Button from '../Button';
import { useSelector } from 'react-redux';

type SearchProps = {
  placeholder?: string;
  onSearch: (query: string) => void;
  className?: string;
  buttonLabel?: string;
};

const SearchBar: React.FC<SearchProps> = ({
  placeholder = 'Type to search',
  onSearch,
  className = '',
  buttonLabel = 'Search',
}) => {
  const [query, setQuery] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    onSearch(e.target.value);
  };

  const handleSearch = () => {
    onSearch(query);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
      onSearch(query);
    }
  };
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries, assets } = contentfulData || {};
  return (
    <div className={`flex flex-1 items-center  ${className}`}>
      <div className="flex items-center flex-1 relative border border-[#dddddd]  overflow-hidden shadow-sm">
        <input
          type="text"
          placeholder={placeholder}
          className="border border-[#cccccc] p-2 pl-3 md:pl-12 flex-1 md:text-lg text-base h-[47px]"
          value={query}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        <img
          src={assets?.search_icon || 'default_image_url'}
          alt="SearchIcon"
          className="absolute left-3 h-5 w-5 opacity-70 pointer-events-none hidden md:block"
        />
      </div>
      {/* //for desktop */}
      <div className="hidden md:hidden">
        <Button
          ariaLabel={buttonLabel}
          variant="solid"
          className="w-[145px] h-[48px] px-[12px] py-[20px] justify-center flex items-center"
          onClick={handleSearch}
        >
          {buttonLabel}
        </Button>
      </div>

      {/* //button only with icon in the mobile view */}

      <div className="block md:hidden">
        <Button
          variant="solid"
          className=" h-[48px] w-[48px] px-[12px] py-[20px] justify-center flex items-center relative"
          onClick={handleSearch}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            className="absolute right-[12px] h-5 w-5 opacity-70 pointer-events-none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.33333 11.7365C5.33333 8.20686 8.20373 5.33646 11.7333 5.33646C15.2629 5.33646 18.1333 8.20686 18.1333 11.7365C18.1333 15.2661 15.2629 18.1365 11.7333 18.1365C8.20373 18.1365 5.33333 15.2661 5.33333 11.7365ZM22.0875 20.5823L18.4661 16.9599C19.5893 15.5157 20.2667 13.7055 20.2667 11.7365C20.2667 7.03139 16.4384 3.20312 11.7333 3.20312C7.02826 3.20312 3.2 7.03139 3.2 11.7365C3.2 16.4415 7.02826 20.2698 11.7333 20.2698C13.7024 20.2698 15.5125 19.5925 16.9568 18.4693L20.5792 22.0906C20.7872 22.2986 21.0603 22.4031 21.3333 22.4031C21.6064 22.4031 21.8795 22.2986 22.0875 22.0906C22.5045 21.6735 22.5045 20.9994 22.0875 20.5823Z"
              fill="white"
            />
          </svg>
        </Button>
      </div>
    </div>
  );
};

export default SearchBar;
